// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ListItem.active:before{border-radius:0 3px 3px 0}.r-map-balloon{display:block;width:244px}.r-map-balloon__img{width:100%;aspect-ratio:16/10;-o-object-fit:cover;object-fit:cover;display:flex;align-items:center;justify-content:center;background:#e4edfb;overflow:hidden}.r-map-balloon__info{padding:12px 16px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
